export const DEFAULT_LIMIT = 50

export const CANVAS_ANIMATION_FIXED_WIDTH = 1920
export const CANVAS_ANIMATION_FIXED_HEIGHT = 1080
export const CANVAS_ANIMATION_DELAY_TO_SHOW = 1000
export const CANVAS_ANIMATION_DELAY_TO_HIDE = 4000

export enum SORT_TYPE {
  BY_DATE = 'BY_DATE',
  BY_NAME = 'BY_NAME'
}

export const SORT_OPTIONS = {
  [SORT_TYPE.BY_DATE]: false,
  [SORT_TYPE.BY_NAME]: true
}

export const stepsStatuses = {
  in_progress: 'In progress',
  pending: 'Pending',
  complete: 'Complete'
}

export const stepsInfo = [
  {
    name: 'details',
    title: 'Project Details',
  },
  {
    name: 'links',
    title: 'ISAAC Links'
  },
  {
    name: 'stories',
    title: 'Stories'
  },
  {
    name: 'preview',
    title: 'Preview'
  }
]
